import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { NDADocumentV3 } from './NDADocumentV3';
import { NDATemplateEditor } from './NDATemplateEditor';
import { FileText, Edit } from 'lucide-react';

export const NDAManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState('generate');

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="generate" className="flex items-center gap-2">
            <FileText className="w-4 h-4" />
            Générer un NDA
          </TabsTrigger>
          <TabsTrigger value="edit" className="flex items-center gap-2">
            <Edit className="w-4 h-4" />
            Éditer le Template
          </TabsTrigger>
        </TabsList>

        <TabsContent value="generate" className="mt-6">
          <NDADocumentV3 />
        </TabsContent>

        <TabsContent value="edit" className="mt-6">
          <NDATemplateEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
};

